<template>
    <div class="formEditor">
      <h3 class="tit">{{ t('Profile.EditApelido.Title') }}</h3>

      <div class="p-4 pt-3 text-15">
        <h6 class="text-15 pb-2 text-white/75">{{ t('Profile.EditApelido.Subtitle') }}</h6>
        <van-field v-model="nickname" :placeholder="t('Profile.EditApelido.Placeholder')" autocomplete="off" autocapitalize="off"
          :formatter="formatAccount" />

        <div class="flex w-full gap-4 mt-6 text-white/75">
          <van-button @click="close" class="primaryBtn_transparent">{{ t('Common.Cancel') }}</van-button>
          <van-button @click="confirm" class="primaryBtn">{{ t('Common.Confirm') }}</van-button>
        </div>
      </div>
    </div>
</template>

<script setup lang="ts">
  import { editNickname } from '@/api'
  import { useUserInfo } from '@/store'
  import i18n from "@/i18n";
  const t = i18n.global.t;
  const nickname = ref(useUserInfo().userInfo!.nickname)

  const formatAccount = (value: string) => {
    return value.replace(/\s/g, '');
  }

  const {close} = defineProps<{
    close: () => void
  }>()

  const confirm = async () => {
    showLoadingToast({
      message: t('Common.Loading'),
      zIndex: 2999,
    })
    const { code } = await editNickname({ nickname: nickname.value }).catch(() => ({ code: 0 }))
    if (code === 1) {
      useUserInfo().userInfo!.nickname = nickname.value
      close()
    }
  }
</script>

<style lang="scss" scoped>
.formEditor{
  --input-focus-bg-color: #FFFFFF2A;
  --van-cell-background: #FFFFFF1A;

  .tit{
    @apply text-[15px] font-[600] h-[44px] bg-[var(--theme-gray-green40)] text-white text-center leading-[44px];
  }
}
</style>
